import React from 'react';
import ReportFrame from './ReportFrame';

export default class ServicesSummary extends React.Component {
  static defaultProps = {
    OpportunityId: 0,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <ReportFrame
        reportName='Opportunity Services Summary'
        reportParams={{ OpportunityId: this.props.OpportunityId.toString() }}
        id='servicesSummaryReport'
        name='servicesSummaryReport'
        title='Services Summary Report'
      />
    );
  }
}
